import script from "./campaigns.vue?vue&type=script&setup=true&lang=jsx"
export * from "./campaigns.vue?vue&type=script&setup=true&lang=jsx"

import "./campaigns.vue?vue&type=style&index=0&id=0413a57d&lang=less"

const __exports__ = script;

export default __exports__